<template>
  <div class="drvers">
    <RedeemsList >
      <PageTitle title="WALLETS.TITLE" subtitle="TRANSPORTATION.SUBTITLE">
        <!-- <Button @click="handleAddTransport">
          <span class="fs-16">{{ $t("GLOBAL.ADD_WALLET") }}</span>
          <img class="mx-2" src="@/assets/images/icons/add-user.svg" />
        </Button> -->
      </PageTitle>
    </RedeemsList>
  </div>
</template>
<script>
import RedeemsList from "@/components/Modules/Redeems/RedeemsList/index.vue"
import PageTitle from "@/components/Shared/PageTitle/index.vue"
export default {
  components: {
    RedeemsList,
    PageTitle
  },
  methods:{
    handleAddTransport(){
      // alert('test')
      this.$bvModal.show("add-transport")
    }
  }
}
</script>